var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportDashboardMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 8.24267L5 4.94267L5.94267 4L10.1853 8.24267L5.94267 12.4853L5 11.5427L8.3 8.24267Z",
    fill: "var(--mono-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportDashboardMore);
export default __webpack_public_path__ + "static/media/report-dashboard-more.752e00cf8360f6deac6f69dfebdba1aa.svg";
export { ForwardRef as ReactComponent };